import type { Store } from '@nexus/store';
import { exportWorkspace, zipFiles } from '@nexus/workspace';
import { isTauri } from '@nexus/store/tauri';

const stamp = () => new Date().toISOString().slice(0, 10);

/** Save bytes as a file: a save dialog on the desktop, a download in the browser. */
export async function saveFile(
  name: string,
  data: Uint8Array,
  mime: string,
  filter: { name: string; extensions: string[] } = { name: 'Zip', extensions: ['zip'] },
): Promise<boolean> {
  if (isTauri()) {
    const { save } = await import('@tauri-apps/plugin-dialog');
    const { writeFile } = await import('@tauri-apps/plugin-fs');
    const path = await save({ defaultPath: name, filters: [filter] });
    if (!path) return false;
    await writeFile(path, data);
    return true;
  }
  const url = URL.createObjectURL(new Blob([data as BlobPart], { type: mime }));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
  return true;
}

/** Whole workspace → Markdown folder (zip), Obsidian-compatible. */
export async function exportToZip(
  store: Store,
  onProgress?: (done: number, total: number) => void,
): Promise<boolean> {
  const files = await exportWorkspace(store, onProgress);
  return saveFile(`Nexus-export-${stamp()}.zip`, zipFiles(files), 'application/zip');
}
